import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CustomDashboardStore, ProjectsDataModelRef, ProjectStatsModelRef } from "../domain/dashboard.model";


export const fetchCustomProjectStatsData = createAsyncThunk<
  ProjectStatsModelRef[],
  void
>("dashboard/fetchCustomProjectStatsData", async () => {
  return [
    {
    title: "Total Projects",
    subtitle: "10",
    icon: "PiFolders",
    percentages: { red: "30%", green: "50%", gray: "20%" },
  },
  {
    title: "On Track",
    subtitle: "6",
    icon: "CiFlag1",
    percentages: { red: "0%", green: "100%", gray: "0%" },
  },
  {
    title: "Completed",
    subtitle: "2",
    icon: "AiOutlineFileDone",

    percentages: { red: "0%", green: "0%", gray: "100%" },
  },
  {
    title: "Delay",
    subtitle: "2",
    icon: "GiSandsOfTime",

    percentages: { red: "100%", green: "0%", gray: "0%" },
  },
  {
    title: "Total Tasks",
    subtitle: "10",
    icon: "PiFolders",

    percentages: { red: "30%", green: "50%", gray: "20%" },
  },
  {
    title: "On Track",
    subtitle: "6",
    icon: "CiFlag1",
    percentages: { red: "0%", green: "100%", gray: "0%" },
  },
  {
    title: "Completed",
    subtitle: "2",
    icon: "AiOutlineFileDone",

    percentages: { red: "0%", green: "0%", gray: "100%" },
  },
  {
    title: "Delay",
    subtitle: "2",
    icon: "GiSandsOfTime",

    percentages: { red: "100%", green: "0%", gray: "0%" },
  },
  ];
});

export const fetchCustomProjectsData = createAsyncThunk<
  ProjectsDataModelRef[],
  void
>("dashboard/fetchCustomProjectsData", async () => {
  return [
    {
      projectName: "YED-PPD",
      startDate: "7 Sep 2024",
      endDate: "17 Sep 2024",
      duration: "10 days",
      status: "onTrack",
    },
    {
      projectName: "YED-PPD",
      startDate: "7 Sep 2024",
      endDate: "17 Sep 2024",
      duration: "10 days",
      status: "onTrack",
    },
    {
      projectName: "YED-PPD",
      startDate: "7 Sep 2024",
      endDate: "17 Sep 2024",
      duration: "10 days",
      status: "onTrack",
    },
   
  ];
});

const customDashboardSlice = createSlice({
  name: "customDashboard",
  initialState: {
    projectStatsMinimal: {
      status: "loading",
      error: null,
      data: [],
    },
    projectsDataMinimal: {
      status: "loading",
      error: null,
      data: [],
    },
  } as CustomDashboardStore,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomProjectStatsData.pending, (state, action) => {
        state.projectStatsMinimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchCustomProjectStatsData.fulfilled, (state, action) => {
        state.projectStatsMinimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchCustomProjectStatsData.rejected, (state, action) => {
        state.projectStatsMinimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      })
      .addCase(fetchCustomProjectsData.pending, (state, action) => {
        state.projectsDataMinimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchCustomProjectsData.fulfilled, (state, action) => {
        state.projectsDataMinimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchCustomProjectsData.rejected, (state, action) => {
        state.projectsDataMinimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      })
     
  },
});

export default customDashboardSlice.reducer;
